import { getNowStart, getNowEnd } from "../tools";
import { periodTypes } from "../const";

const updateUi = (state, action) => {
  if (state === undefined || action?.type === 'RESET') {

    return {
      paletteWidth: 280,
      rangerHeight:43,
      selectedGeoObj: undefined,
      selectedGeoObjArr: undefined,
      geoObjCriteria:"1",
      dateRangeCriteria:periodTypes.TODAY,
      rangeStartDate:getNowStart(),
      rangeEndDate:getNowEnd(),
      isDrawerOpen: true,
      isLeftMenuMobileOpen: false,
      isShowRouteTooltips: false,
    }
  }

  const { ui:data } = state

  switch(action.type){
    case 'SET_UI_PALETTE_WIDTH':
      return {...data, paletteWidth:action.payload};
    case 'SET_UI_RANGER_HEIGHT':
      return {...data, rangerHeight:action.payload};
    case 'SET_UI_GEO_OBJ':
      return {...data, selectedGeoObj:action.payload};
    case 'SET_UI_GEO_OBJ_ARR':
      return {...data, selectedGeoObjArray:action.payload};
    case 'SET_UI_GEO_OBJ_CRITERIA':
      return {...data, geoObjCriteria:action.payload};
    case 'SET_UI_DATE_RANGE_CRITERIA':
      return {...data, dateRangeCriteria:action.payload};
    case 'SET_UI_RANGE_START_DATE':
      return {...data, rangeStartDate:action.payload};
    case 'SET_UI_RANGE_END_DATE':
      return {...data, rangeEndDate:action.payload};
    case 'SET_UI_DRAWER_OPEN':
      return {...data, isDrawerOpen: action.payload};
    case 'SET_UI_MOBILE_BLOCK_LEFT_MENU_OPEN':
      return {...data, isLeftMenuMobileOpen: action.payload};
    case 'SET_UI_SHOW_ROUTE_TOOLTIPS':
      return {...data, isShowRouteTooltips: action.payload};
    case 'SET_UI_SHOW_MOBILE_MENUS':
      return {...data, burgerMenuOpened: action.payload};
    default:
      return data;
  }
}

export default updateUi;
